<app-splash-screen></app-splash-screen>
<app-update-screen></app-update-screen>

<ion-app>
  @if($native){
  <div class="app-navbar-notch"></div>
  }
  @if(auth.isImpersonating){
  <div class="impersonation-banner">
    <ion-icon name="eye-outline"></ion-icon>
    <span class="impersonation-banner__text">
      {{ 'PROFILE.IMPERSONATE.BANNER' | translate }} <b>{{ auth.impersonatedUser?.email }}</b>
    </span>
    <ion-button size="small" fill="solid" color="light" (click)="stopImpersonation()">
      {{ 'PROFILE.IMPERSONATE.RETURN' | translate }}
    </ion-button>
  </div>
  }
  <ion-content scrollY="false" id="main-content">

    <app-map [center]="mapCenter" [data]="data" [updates]="updates" [reload]="mapReload"
      [selectedInstallation]="mainStateService.$selectedInstallation()" (clickItem)="onMapClicked($event)"
      (mapBounds)="onMapBoundsChanged($event)">
    </app-map>

    @if(!mainStateService.$searchPanelVisible()){
    <div class="fab-container-left">
      <div class="left-side">
        <ion-fab>
          <ion-fab-button (click)="showSearch()" color="light">
            <ion-icon name="search"></ion-icon>
          </ion-fab-button>
        </ion-fab>
      </div>
    </div>

    <div class="fab-container-right">
      <ion-fab class="funnel-fab">
        <ion-fab-button (click)="presentFilter()" [color]="$filterButtonColor()">
          @if(!$showFilters()){
          <ion-icon name="funnel-outline"></ion-icon>
          }
          @else{
          <ion-icon name="close-outline" size="large"></ion-icon>
          }
        </ion-fab-button>
      </ion-fab>
    </div>
    }

    @if($showFilters()){
    <yf-filter-modal [@inOutAnimation] (filterChange)="onMapBoundsChanged($event)"></yf-filter-modal>
    }

    <yf-search-panel (showPosition)="this.searchResult($event)"></yf-search-panel>

    @if($showSessionToast()){
    <yf-session-toast (componentEvent)="sessionToastEvent($event)">
    </yf-session-toast>
    }

    @if(mainStateService.$selectedInstallation()){
    <yf-installation [currentPosition]="this.currentPosition" (openLogin)="presentLogin({ type: 'login' })"
      (onSelectPrev)="selectPrev($event)" (onSelectNext)="selectNext($event)">
    </yf-installation>
    }

    <yf-cluster></yf-cluster>

    <yf-app-status-leds></yf-app-status-leds>
  </ion-content>

  <ion-footer>
    @if(!!(user$ | async)){
    <ion-toolbar color="secondary">
      <ion-buttons>
        <div slot="start">
          <ion-button>
            <ion-menu-toggle>
              <ion-icon name="ellipsis-vertical-outline"></ion-icon>
            </ion-menu-toggle>
          </ion-button>
        </div>
        <div class="footer-button-container" slot="center">
          <ion-button (click)="showNotificationModal()">
            <!-- <ion-icon src="./../assets/app-icons/notification.svg"></ion-icon> -->
            <ion-icon name="notifications-outline"></ion-icon>
            @if($unreadNotificationsCount() > 0) {
            <ion-badge color="danger" class="notification-badge">
              {{ $unreadNotificationsCount() }}
            </ion-badge>
            }
          </ion-button>

          <ion-button (click)="presentUserSessions()">
            <ion-icon src="./../assets/app-icons/history.svg"></ion-icon>
          </ion-button>
        </div>
        <div slot="end">
          <ion-button (click)="_showAppInfo()"><ion-icon slot="icon-only" name="information-circle-outline"
              color="light"></ion-icon></ion-button>
        </div>
      </ion-buttons>

    </ion-toolbar>
    }
    @else {
    <ion-toolbar color="primary">
      <ion-buttons slot="secondary">
        <ion-button (click)="presentLogin({ type: 'login' })"><ion-icon slot="start" name="enter-outline"></ion-icon>{{
          "LOGIN.LOGIN" | translate }}</ion-button>
      </ion-buttons>
      <ion-buttons slot="primary">
        <ion-button (click)="_showAppInfo()"><ion-icon slot="icon-only"
            name="information-circle-outline"></ion-icon></ion-button>
      </ion-buttons>
    </ion-toolbar>
    }

  </ion-footer>

  <yf-main-menu (itemClicked)="itemClicked($event)"></yf-main-menu>

</ion-app>
